import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import type { AxiosError } from 'axios';

import { NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { connectorKeys } from '@/shared/lib/query/queryKeys';

import { deleteConnectorsApi, type DeleteConnectorsRequest } from '@/entities/connector';
import type { ConnectorApiError } from '@/entities/connector';

export const useDeleteConnectors = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: DeleteConnectorsRequest) => deleteConnectorsApi(request),
    onSuccess: (_data, _variables) => {
      const connectorIds = _variables.ids;

      queryClient.invalidateQueries({ queryKey: connectorKeys.list() });
      connectorIds.forEach((id) => {
        queryClient.invalidateQueries({ queryKey: connectorKeys.detail(id) });
      });

      message.success(NOTIFICATION_MESSAGES.CONNECTOR_DELETE_ALL_SUCCESS_DESC);
    },
    onError: (error: AxiosError<ConnectorApiError>) => {
      const errorMessage = error.response?.data?.message ?? NOTIFICATION_MESSAGES.CONNECTOR_DELETE_ERROR_DESC;
      message.error(errorMessage);
    },
  });
};
